import { Component, ViewEncapsulation, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-add-event-modal',
  templateUrl: './add-event-modal.component.html',
  styleUrls: ['./add-event-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AddEventModalComponent implements AfterViewInit {


  ngAfterViewInit(): void {

  }
}